<script>
  import { navigate, back, querystring } from "../router";
  import { getUser } from "../user.js";
  import { onMount } from "svelte";
  import { info } from "../wedding.js";
  import { extractParams } from "../utils.js";
  import { Button, Label } from "../component/widget";
  import CookieConsent from "../component/CookieConsent.svelte";
  import Header from "../component/Header.svelte";
  import Copyright from "../component/Copyright.svelte";
  import { default as Banner } from "../component/blog/Banner.svelte";
  import { default as Content } from "../component/blog/Content.svelte";
  import Rsvp from "../component/Rsvp.svelte";
  import Contact from "../component/Contact.svelte";

  export let wedding_guid;
  export let category;
  export let article_id;

  let wedding;
  let isOwner = false;
  let isAnonymous = true;

  let hasEdit = false;
  let isEdit = null;
  let isRsvp = false;
  let isContact = false;
  let isBapteme = false;

  $: {
    isRsvp = extractParams("rsvp", $querystring, true);
    hasEdit = extractParams("edit", $querystring, true);
    isEdit = extractParams("edit", $querystring);
    isContact = extractParams("contact", $querystring, true);
    isBapteme = extractParams("b", $querystring, true);
  }

  //$: console.log(hasEdit, isEdit);

  let userRequest;

  onMount(() => {
    console.log("Wedding on mount", isEdit, wedding_guid);

    userRequest = getUser();

    const unsubscribe = userRequest.subscribe((promise) => {
      promise
        .then(async (u) => {
          isAnonymous = false
          if (hasEdit && u.data.verified == "0") {
            navigate("/");
          } else {
            let r = await info(wedding_guid, hasEdit ? true : undefined);
            wedding = r.data;
            isOwner = wedding.owner_id !== undefined;
          }
        })
        .catch(async (e) => {
          isAnonymous = true
          if (hasEdit) {
            navigate("/");
          } else {
            let r = await info(wedding_guid, undefined);
            wedding = r.data;
          }
          //console.log(e);
        });
    });

    return () => {
      console.log("Wedding destroy");
      unsubscribe();
    };
  });
</script>

<main>
  <CookieConsent />
  <Header>
    <div slot="left">
      {#if isOwner}
        <Button action={() => navigate(`#/dashboard/${wedding_guid}`)}>
          <Label text="Dashboard" icon="tachometer-alt" borderLeft h="48px" />
        </Button>
      {:else if !isAnonymous}
        <Button action={() => navigate(`#/select`)}>
          <Label text="Changer de mariage" icon="sync" borderLeft h="48px" />
        </Button>
      {/if}
    </div>
  </Header>

  {#if isRsvp}
    <Rsvp {wedding_guid} {isBapteme} on:close={() => back()} />
  {/if}

  {#if isContact}
    <Contact {wedding_guid} on:close={() => back()} />
  {/if}

  {#if wedding}
    <Banner {wedding} {isOwner} isEdit={isEdit == "true"} />
    <Content {wedding} {isOwner} isEdit={isEdit == "true"} {hasEdit} {category} {article_id} />
  {/if}

  <Copyright company="KiwisApp" />
</main>

<style>
  main {
    width: 100%;
  }
</style>
